import React from 'react';
import PropTypes from 'prop-types';

const style = {
  color: 'red',
  position: 'relative',
  fontSize: 10,
  marginTop: 0,
  width: '100%',
};

const styleCentered = Object.assign({}, style);
styleCentered.textAlign = 'center';
styleCentered.marginLeft = -15;

const Error = ({ centered, style: customStyle, children }) => (
  <div style={!centered ? Object.assign({}, style, customStyle) : Object.assign({}, styleCentered, customStyle)}>
    {children}
  </div>
);

Error.propTypes = {
  children: PropTypes.string,
  centered: PropTypes.bool,
  style: PropTypes.object,
};

export default Error;



// WEBPACK FOOTER //
// ./app/components/Forms/UI/ErrorMessage/index.js